import styles from './styles.module.scss';

export const CustomOption = ({ children, ...props }: any) => {
  const { innerProps, innerRef } = props;

  return (
    <div className={styles.customOption}>
      <div ref={innerRef} {...innerProps} className={styles.optionTitle}>
        <h6 className={styles.title}>{children}</h6>
      </div>
    </div>
  );
};
